import { Box } from "@mui/material";
import {
  BankAccountSetup,
  BankAccountSetupSkeleton,
} from "./practiceSetupPart2";

/**
 * Renders the Bank Account setup UI but hides the header's internal
 * `x/y Connected` chip so parent pages can show it in their own header.
 */
export function BankConnectedAccountsStep(props) {
  return (
    <Box
      sx={{
        // BankAccountSetup root -> first child is the "Account Setup" header.
        // Hide only chips inside that header (do not hide table chips).
        "& > div > :first-of-type .MuiChip-root": {
          display: "none",
        },
      }}
    >
      <BankAccountSetup {...props} />
    </Box>
  );
}

/**
 * Skeleton variant for the connected accounts table.
 * Hides the header skeleton so the parent can render its own header/pill.
 */
export function BankConnectedAccountsStepSkeleton(props) {
  return (
    <Box
      sx={{
        // BankAccountSetupSkeleton root -> first child is the header area.
        "& > div > :first-of-type": {
          display: "none",
        },
      }}
    >
      <BankAccountSetupSkeleton {...props} />
    </Box>
  );
}

/**
 * Connected-accounts UI without the "Account Setup" header (and without the
 * internal x/y Connected pill).
 *
 * Useful for pages where the header/copy belongs elsewhere.
 */
export function BankConnectedAccountsTableOnly(props) {
  return <BankAccountSetup {...props} hideAccountSetupHeader={true} />;
}

export function BankConnectedAccountsTableOnlySkeleton(props) {
  return <BankAccountSetupSkeleton {...props} hideAccountSetupHeader={true} />;
}

